import { BaseModel } from "sjs-base-model";

// Returned Api Data sample
// const example = {
//     totalSale: 22138,
//     noTransactions: 12,
//     uniqueUsers: 6
// };

export default class OneOffsStatSummaryModel extends BaseModel {
    totalSale = 0;
    noOrders = 0;
    uniqueUsers = 0;

    constructor(data) {
        super();
        this.update(data);
    }
}
